(function () {
    'use strict';

    angular
        .module('Lavpop-store.directives')
        .directive('storeSteps', StoreSteps)

    /** @ngInject */
    function StoreSteps(PATHS) {
        function StoreStepsController() {
            const vm = this;
        }

        return {
            bindToController: true,
            controller: StoreStepsController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/store-steps/store-steps.html`,
            scope: {
                currentStep: '='
            }
        }
    }
}());